import React from 'react';
import { Grid } from '@mui/material';
import CustomizedProgressBars from '../progressbar';

const TimeTracking = ({ allocatedHours, hoursSpent }) => {
  return (
    <div className="box">
      <Grid item className="allocated-hours">
        <p>Time Tracking</p>
        <div className="time-tracking-input taskdetail-sidebar-right-col">
          <CustomizedProgressBars
            allocatedHours={allocatedHours}
            hoursSpent={hoursSpent}
          />
        </div>
      </Grid>
    </div>
  );
};

export default React.memo(TimeTracking);